import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { Faculty, Queue, ResponseWrapper } from '../models';
import { Converter, createRequestOption } from '../shared';
import { BaseService } from './base-service';

@Injectable()
export class FacultyService implements BaseService<Faculty> {

    private resourceUrl = 'api/faculties';
    private publicResourceUrl = 'api/public/faculties';

    constructor(private http: Http) {
    }

    create(faculty: Faculty): Observable<Faculty> {
        const copy = Converter.toJson(faculty);
        return this.http.post(this.resourceUrl, copy).map((response: Response) => {
            return Converter.fromJson(Faculty, response.json());
        });
    }

    update(faculty: Faculty): Observable<Faculty> {
        const copy = Converter.toJson(faculty);
        return this.http.put(this.resourceUrl, copy).map((response: Response) => {
            return Converter.fromJson(Faculty, response.json());
        });
    }

    find(id: number): Observable<Faculty> {
        return this.http.get(`${this.publicResourceUrl}/${id}`).map((response: Response) => {
            return Converter.fromJson(Faculty, response.json());
        });
    }

    all(): Observable<Array<Faculty>> {
        return this.http.get(this.publicResourceUrl).map((response: Response) => {
            return Converter.fromJsonArray(Faculty, response.json());
        });
    }

    query(request?: any): Observable<ResponseWrapper> {
        const options = createRequestOption(request);
        return this.http.get(this.publicResourceUrl, options).map((response: Response) => {
            const result = Converter.fromJsonArray(Faculty, response.json());
            return Converter.toResponseWrapper(result, response);
        });
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    findQueues(id: number): Observable<Array<Queue>> {
        return this.http.get(`${this.resourceUrl}/${id}/queues`).map((response: Response) => {
            return Converter.fromJsonArray(Queue, response.json());
        });
    }

    findQueuesPublic(id: number): Observable<Array<Queue>> {
        return this.http.get(`${this.publicResourceUrl}/${id}/queues`).map((response: Response) => {
            return Converter.fromJsonArray(Queue, response.json());
        });
    }

    findFinalQueues(id: number): Observable<Array<Queue>> {
        return this.http.get(`${this.resourceUrl}/${id}/final-queues`).map((response: Response) => {
            return Converter.fromJsonArray(Queue, response.json());
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/services/faculty.service.ts